import { render } from "./list.vue?vue&type=template&id=1bab8502"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=1bab8502&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__